<template>
    <div id="uploadModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h5" id="uploadTitle">Select a file to upload.</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body"> 
                    <div class="form-group">
                        <select class="custom-select" id="document_type_id" name="document_type_id" v-model="documentType">
                            <option v-for="option in options" :key="option.id" :value="option.id" v-text="option.name"></option>
                        </select>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control" id="file-upload-description" placeholder="Description" v-model="description">
                    </div>
                    <div v-if="submissionDocumentTypes.includes(documentType)" class="mb-3">
                        <div class="d-flex justify-content-around align-items-center">
                            <div class="custom-control custom-control-inline custom-radio">
                                <input id="file-upload-faxed-radio" type="radio" class="custom-control-input" :value="TransmissionMethod.FAX" v-model="submitMethod">
                                <label class="custom-control-label align-top" for="file-upload-faxed-radio">Faxed</label>
                            </div>
                            <div class="custom-control custom-control-inline custom-radio">
                                <input id="file-upload-emailed-radio" type="radio" class="custom-control-input" :value="TransmissionMethod.EMAIL" v-model="submitMethod">
                                <label class="custom-control-label align-top" for="file-upload-emailed-radio">Emailed</label>
                            </div>                         
                            <div class="custom-control custom-control-inline custom-radio">
                                <input id="file-upload-mailed-radio" type="radio" class="custom-control-input" :value="TransmissionMethod.MAILED" v-model="submitMethod">
                                <label class="custom-control-label align-top" for="file-upload-mailed-radio">Mailed</label>
                            </div>
                            <div class="font-weight-bold mx-2">On</div>
                            <div><input id="submittedAt" type="date" class="form-control form-control-sm" v-model="submitDate"></div>                            
                        </div>
                    </div>
                    <div v-if="documentType == DocumentType.LWC_FORM_1010" class="form-group d-flex d-flex-row p-2 border">
                        <div class="mr-3 align-self-center"><i class="fas fa-exclamation-triangle fa-2x text-warning"></i></div>
                        <div class="align-self-center"><small class="font-weight-bold"><p>{{ message }}</p></small></div>             
                    </div>                                      
                    <form method="post" action="#" files="true" enctype="multipart/form-data" id="upload-dropzone" class="dropzone"> 
                        <input type="hidden" name="_token" :value="csrf">             
                        <input type="hidden" name="claim_id" :value="claimId">
                        <input type="hidden" name="client_id" :value="clientId">
                        <input type="hidden" name="document_type_id" :value="documentType">
                        <input type="hidden" name="description" :value="description">
                        <input type="hidden" name="submit_method" :value="submitMethod">
                        <input type="hidden" name="submit_date" :value="submitDate">
                        <input type="hidden" name="associate_to_document_id" :value="associateToDocumentId">
                    </form>
                </div>                        
            </div>
        </div>
    </div>    
</template>

<script>
import { DocumentType, TransmissionMethod } from '../constants.js';

export default {
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            options: [],
            documentType: '',
            description: '',
            submitMethod: null,
            submitDate: null,
            attachToDocumentId: null,
            associateToDocumentId: null,
            claimId: null,
            clientId: null,
            spinnerActive: false,
            clientFax: '',

            // this allows us to use imported objects in the template
            DocumentType: DocumentType, 
            TransmissionMethod: TransmissionMethod
        }
    },    
    computed: {
        message: function () {
            let faxNumber = this.clientFax ? ', ' + Vue.filter('telephone')(this.clientFax) + ',' : '';
            return 'Ensure the Health Care Provider Fax Number in Section 2 of your LWC Form 1010 is your Worx Client Fax Number' + faxNumber + ' before uploading the document.';
        },
        submissionDocumentTypes: function () {
            return [DocumentType.LWC_FORM_1010, DocumentType.LWC_FORM_1009, DocumentType.CMS_1500, DocumentType.CMS_1450];
        }
    },
    methods: {
        showModal: function(data) {
            
            this.claimId = data.claimId;
            this.clientId = data.clientId;
            this.options = data.options;
            this.documentType = data.documentType;
            this.description = data.description ?? '';
            this.submitMethod = null;
            this.submitDate = data.submitDate ?? null;
            this.associateToDocumentId = data.associateToDocumentId;

            $('.dropzone').get(0).dropzone.options.url = data.url;

            $('#uploadModal').modal('show');
        },
        hideModal: function() {
            $('#uploadModal').modal('hide');           
        },
        showSpinner: function () {
            $("#spinner").modal('show');
            this.spinnerActive = true;            
        },
        hideSpinner: function () {

            // work around to handle hiding the spinner on the claim list page when there is an error
            $("#spinner").on('shown.bs.modal', () => {
                $("#spinner").modal('hide');
            });

            $("#spinner").modal('hide');
            this.spinnerActive = false;
        },
        updateClientFax: function (client) {
            if (client && client.fax_number) {
                this.clientFax = ', ' + client.fax_number + ',';
            }
            else {
                this.clientFax = '';
            }
        },
    },
    mounted() {
        var self = this;
        $('form#uploadModal').on('hidden.bs.modal', function(e) {
            self.description = '';
        });
    },
    created() {
        var self = this;
        eventHub.$on('show-file-upload', self.showModal);
        eventHub.$on('claim-client-changed', self.updateClientFax);

        Dropzone.options.uploadDropzone = {
            maxFilesize: 100, // files 100MB or less this matches php.ini (upload_max_filesize and post_max_size)
            addRemoveLinks: true,
            timeout: 15000,
            autoProcessQueue: true,
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: 1,
            thumbnailHeight: 32,
            // acceptedFiles: "application/pdf,text/plain,image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            init: function() {
                this.on('sending', function(file, xhr, formData) {

                    if (self.documentType == DocumentType.EDI_837) {
                        self.hideModal();                  
                        self.showSpinner();
                    }
                });
                this.on('complete', function(file) {

                    this.removeAllFiles(true);

                    // wait for next dom to be updated before clearing the message
                    self.$nextTick(() => {
                        self.hideSpinner(); 
                        self.hideModal();          
                    });
                });
            },
            success(files, response) {
                
                if (response.redirect) {
                
                    // redirect the browser to thenew location
                    window.location = response.href;
                }
                else if (response.message) {

                    // display message if sent back in the response
                    toastr[response.level](response.message, response.title, {
                        timeOut: response.timeout ? response.timeout : 10000, 
                        positionClass: "toast-top-full-width", 
                        closeButton: true              
                    });                    
                }                             
            },
            error(file, response) {
       
                let title = response.title ? response.title : 'Error';
                let message = response.message ? response.message : response;

                toastr['error'](message, title, {
                    timeOut: response.timeout ? response.timeout : 10000, 
                    positionClass: "toast-top-full-width", 
                    closeButton: true
                });
            }        
        };   
    },
    beforeDestroy() {
        eventHub.$off('show-file-upload');
        eventHub.$off('claim-client-changed');
    },    
}
</script>

<style scoped>

</style>


